import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";

interface Props {
	open: boolean;
	skippedCount: number;
	onContinue: () => void;
}

/**
 * Dialog component that is shown when the user tries to assign a korrektor to a completed korrektur step
 * @param open - Whether the dialog is open
 * @param skippedCount - The number of skipped steps
 * @param onContinue - The function to call when the user clicks the continue button
 */
export function CompletedKorrekturStepsSkippedDialog({
	open,
	skippedCount,
	onContinue,
}: Props) {
	return (
		<Dialog open={open} onOpenChange={(next) => !next && onContinue()}>
			<DialogContent className="sm:max-w-[520px] bg-background-secondary">
				<DialogHeader>
					<DialogTitle>Abgeschlossene Korrekturen übersprungen</DialogTitle>
					<DialogDescription asChild>
						<div className="space-y-3">
							<div className="p-3">
								<p className="font-semibold text-foreground">
									{skippedCount} Korrektur(en) werden übersprungen.
								</p>
								<p>
									Abgeschlossene Korrekturen können nicht erneut zugewiesen
									werden. Die Zuweisung der übrigen Korrekturen wird
									fortgesetzt.
								</p>
							</div>
						</div>
					</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button onClick={onContinue}>Weiter</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
